import {
  ArrowsLeftRightIcon,
  EnvelopeSimpleIcon,
  PackageIcon,
  StorefrontIcon,
  ToteIcon,
  UserCircleIcon,
} from '@phosphor-icons/react'

import { paymentStatuses, refundMethods, returnStatuses, SoftPackageIcon } from '@reveni-io/reveni-ui'

import { providers } from '@/returns/constants'

export const userPermissions = {
  editReturnStatus: 'edit_return_status',
  editIssueRefund: 'edit_issue_refund',
  editRefundMethod: 'edit_refund_method',
  editStoreCreditGiftCard: 'edit_store_credit_gift_card',
  editExchangeOrders: 'edit_exchange_orders',
  editTransactionTotal: 'edit_transaction_total',
  viewMetrics: 'view_metrics',
  viewBilling: 'view_billing',
  viewBillingSettings: 'view_billing_settings',
  editBillingSettings: 'edit_billing_settings',
  viewStore: 'view_store',
  editStore: 'edit_store',
  viewPolicy: 'view_policy',
  editPolicy: 'edit_policy',
  viewAllowedList: 'view_allowed_list',
  editAllowedList: 'edit_allowed_list',
  viewPolicyRules: 'view_policy_rules',
  editPolicyRules: 'edit_policy_rules',
  viewRefunds: 'view_refunds',
  editRefunds: 'edit_refunds',
  viewLogistics: 'view_logistics',
  editLogistics: 'edit_logistics',
  viewReturnReasons: 'view_return_reasons',
  editReturnReasons: 'edit_return_reasons',
  viewBranding: 'view_branding',
  editBranding: 'edit_branding',
  viewCopies: 'view_copies',
  editCopies: 'edit_copies',
  viewCommunications: 'view_communications',
  editCommunications: 'edit_communications',
  viewExtra: 'view_extra',
  editExtra: 'edit_extra',
  viewReturnProtection: 'view_return_protection',
  editReturnProtection: 'edit_return_protection',
  viewOrderTrackingPage: 'view_order_tracking_page',
  editOrderTrackingPage: 'edit_order_tracking_page',
  editReturnLabels: 'edit_return_labels',
  editCustomerData: 'edit_customer_data',
  viewUsers: 'view_users',
  editUsers: 'edit_users',
  editGroups: 'edit_groups',
  viewShipments: 'view_shipments',
  viewShipmentsMetrics: 'view_shipments_metrics',
  prepareShipment: 'prepare_shipment',
  editShipmentDetails: 'edit_shipment_details',
  viewIntegrations: 'view_integrations',
  editIntegrations: 'edit_integrations',
  viewShipmentsInventory: 'view_shipments_inventory',
  editShipmentsInventory: 'edit_shipments_inventory',
  viewShipmentsSettings: 'view_shipments_settings',
  editShipmentsSettings: 'edit_shipments_settings',
  restockProducts: 'edit_restock_products',
  cancelShipment: 'cancel_shipment',
  viewTransactionsDefaultViews: 'view_transactions_default_views',
  editTransactionsViews: 'edit_transactions_views',
  shareTransactionsViews: 'share_transactions_views',
}

export const subscriptionPlans = {
  basic: 'basic',
  advanced: 'advanced',
  premium: 'premium',
}

export const languages = t => [
  { value: 'es', label: t('Español') },
  { value: 'en', label: t('Inglés') },
  { value: 'fr', label: t('Francés') },
  { value: 'de', label: t('Alemán') },
  { value: 'it', label: t('Italiano') },
  { value: 'pt', label: t('Portugués') },
  { value: 'nl', label: t('Neerlandés') },
  { value: 'ko', label: t('Coreano') },
]

export const availableLanguages = ['es', 'en']

export const availableLanguagesForUser = ['es', 'en', 'fr', 'de', 'it', 'pt', 'nl', 'ko']

export const externalGateways = {
  stripe: 'stripe',
  primer: 'primer',
}

export const transactionStatuses = [
  { value: returnStatuses.onHold, label: 'En espera' },
  { value: returnStatuses.pending, label: 'Pendiente' },
  { value: returnStatuses.inProgress, label: 'En proceso' },
  { value: returnStatuses.shipped, label: 'Enviado' },
  { value: returnStatuses.received, label: 'Recibido' },
  { value: returnStatuses.forReview, label: 'Por revisar' },
  { value: returnStatuses.accepted, label: 'Aceptado' },
  { value: returnStatuses.partiallyAccepted, label: 'Acept. parcial' },
  { value: returnStatuses.rejected, label: 'Rechazado' },
  { value: returnStatuses.cancelled, label: 'Cancelado' },
]

export const refundMethodOptions = [
  { value: refundMethods.originalPaymentMethod, label: 'Método de pago original' },
  { value: refundMethods.storeCredit, label: 'Crédito en tienda' },
  { value: refundMethods.giftCard, label: 'Tarjeta regalo' },
  { value: refundMethods.bankTransfer, label: 'Transferencia bancaria' },
]

export const refundStatusOptions = [
  { value: 'pending', label: 'Pendiente' },
  { value: 'completed', label: 'Emitido' },
  { value: 'declined', label: 'Fallido' },
]

export const refundHoldModeValues = {
  holdIndefinitely: 'hold_indefinitely',
  delayByDays: 'delay_by_days',
}

export const issueRefundAtStatusValues = {
  manual: 'manual',
  accepted: 'accepted',
  shipped: 'shipped',
  received: 'received',
}

export const paymentStatusOptions = [
  { value: paymentStatuses.pending, label: 'Pendiente' },
  { value: paymentStatuses.completed, label: 'Completado' },
]

const shipmentTypes = {
  orderShipment: 'order_shipment',
  exchangeShipment: 'exchange_shipment',
  returnShipment: 'return_shipment',
}

export const shipmentTypeOptions = [
  { value: shipmentTypes.orderShipment, label: 'Envío de pedido' },
  { value: shipmentTypes.exchangeShipment, label: 'Envío de cambio' },
  { value: shipmentTypes.returnShipment, label: 'Envío de devolución' },
]

export const shippingLabelFormatValues = {
  pdf: 'pdf',
  zpl: 'zpl',
  pdfAndZpl: 'pdf_and_zpl',
}

export const manageCarrierServiceTypes = {
  manual: 'manual',
  auto: 'auto',
}

export const dimensionUnits = [
  {
    label: 'centímetros',
    value: 'cm',
  },
  {
    label: 'pulgadas',
    value: 'in',
  },
]

export const packagingTypes = {
  box: 'box',
  envelope: 'envelope',
  softPackaging: 'soft_packaging',
}

export const packagingTypeIcons = {
  [packagingTypes.box]: PackageIcon,
  [packagingTypes.envelope]: EnvelopeSimpleIcon,
  [packagingTypes.softPackaging]: SoftPackageIcon,
}

export const weightUnits = [
  {
    label: 'kilogramos',
    value: 'kg',
  },
  {
    label: 'gramos',
    value: 'g',
  },
  {
    label: 'libras',
    value: 'lb',
  },
  {
    label: 'onzas',
    value: 'oz',
  },
]

export const emailTypes = {
  shipments: 'shipments',
  returns: 'returns',
}

export const claimTypeValues = {
  carrierMarkedDeliveredNotReceived: 'carrier_marked_delivered_not_received',
  possiblyLostNoTrackingUpdates: 'possibly_lost_no_tracking_updates',
  deliveredDamagedOrMissingItems: 'delivered_damaged_or_missing_items',
  packageHeldAtCustoms: 'package_held_at_customs',
}

export const claimStatusValues = {
  announce: 'announce',
  opened: 'opened',
  inReview: 'in_review',
  approved: 'carrier_approved',
  denied: 'carrier_denied',
  closed: 'closed',
}

export const emailVariablesSections = [
  {
    label: 'Tienda',
    Icon: StorefrontIcon,
    id: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Cliente',
    Icon: UserCircleIcon,
    id: 'customer',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Pedido',
    Icon: ToteIcon,
    id: 'order',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Transacción',
    Icon: ArrowsLeftRightIcon,
    id: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Envío',
    Icon: PackageIcon,
    id: 'shipment',
    availableFor: [emailTypes.shipments],
  },
]

export const emailVariables = [
  {
    label: 'Nombre de la tienda',
    type: 'text',
    variable: '{{store_name}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL de la tienda',
    type: 'link',
    variable: '{{store_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL del portal de devoluciones',
    type: 'link',
    variable: '{{store_return_portal_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL del panel de cliente',
    type: 'link',
    variable: '{{store_cd_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Correo de contacto',
    type: 'text',
    variable: '{{store_contact_email}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL de contacto',
    type: 'link',
    variable: '{{store_contact_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL política de devoluciones',
    type: 'link',
    variable: '{{store_returns_policy_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL del Centro de Ayuda',
    type: 'link',
    variable: '{{store_help_center_url}}',
    section: 'store',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Nombre',
    type: 'text',
    variable: '{{customer_first_name}}',
    section: 'customer',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Apellidos',
    type: 'text',
    variable: '{{customer_last_name}}',
    section: 'customer',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Correo electrónico',
    type: 'text',
    variable: '{{customer_email}}',
    section: 'customer',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Número de pedido',
    type: 'text',
    variable: '{{order_name}}',
    section: 'order',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL de devolución',
    type: 'link',
    variable: '{{order_return_url}}',
    section: 'order',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'URL de seguimiento del pedido',
    type: 'link',
    variable: '{{order_tracking_url}}',
    section: 'order',
    availableFor: [emailTypes.returns, emailTypes.shipments],
  },
  {
    label: 'Enlace de recuperación de pedido',
    type: 'link',
    variable: '{{order_recovery_link}}',
    section: 'order',
    availableFor: [emailTypes.returns],
    onlyForTrigger: 'order_recovery_link_requested',
  },
  {
    label: 'Número de secuencia de devolución',
    type: 'text',
    variable: '{{transaction_sequence_number}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Tipo de transacción',
    type: 'text',
    variable: '{{transaction_type_display}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Modo de transacción',
    type: 'text',
    variable: '{{transaction_mode}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Estado de la transacción',
    type: 'text',
    variable: '{{transaction_status_display}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'URL del panel de cliente',
    type: 'link',
    variable: '{{transaction_cd_url}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Transportista de la devolución',
    type: 'text',
    variable: '{{transaction_return_carrier}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Importe total reembolsado',
    type: 'text',
    variable: '{{transaction_total_refunded_amount}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Cuenta bancaria del reembolso',
    type: 'text',
    variable: '{{transaction_refund_bank_account}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Importe del pago',
    type: 'text',
    variable: '{{transaction_payment_amount}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'URL del enlace de pago',
    type: 'link',
    variable: '{{transaction_payment_link}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Motivo de rechazo de la solicitud en espera',
    type: 'text',
    variable: '{{on_hold_decline_reason}}',
    section: 'transaction',
    availableFor: [emailTypes.returns],
  },
  {
    label: 'Estado del envío',
    type: 'text',
    variable: '{{shipment_status}}',
    section: 'shipment',
    availableFor: [emailTypes.shipments],
  },
  {
    label: 'Dirección de destino',
    type: 'text',
    variable: '{{shipment_destination_address}}',
    section: 'shipment',
    availableFor: [emailTypes.shipments],
  },
  {
    label: 'Transportista del envío',
    type: 'text',
    variable: '{{shipment_carrier}}',
    section: 'shipment',
    availableFor: [emailTypes.shipments],
  },
  {
    label: 'URL página de seguimiento',
    type: 'link',
    variable: '{{shipment_tracking_url}}',
    section: 'shipment',
    availableFor: [emailTypes.shipments],
  },
]

export const baseReasons = t => [
  { value: 'not_like_shown', label: t('El producto no es como se mostraba') },
  { value: 'dislike', label: t('No me gusta ') },
  { value: 'bought_many_to_try', label: t('Compré varias opciones para probar') },
  { value: 'too_small', label: t('Me queda pequeño') },
  { value: 'too_big', label: t('Me queda grande') },
  { value: 'uncomfortable', label: t('Es incomodo o me hace daño') },
  { value: 'damaged', label: t('El producto está dañado') },
  { value: 'wrong_item', label: t('Recibí el producto equivocado') },
  { value: 'late', label: t('El producto llegó demasiado tarde') },
  { value: 'unable_to_exchange', label: t('No es posible cambiarlo por otro producto') },
  { value: 'unknown', label: t('Otro motivo') },
]

export const baseReasonsByLanguage = {
  not_like_shown: {
    es: 'El producto no es como se mostraba',
    en: "The product wasn't like shown",
    fr: "Le produit n'était pas conforme à l'image",
    it: 'Il prodotto non era come mostrato',
    de: 'Das Produkt entspricht nicht der Abbildung',
    pt: 'O produto não era como mostrado',
  },
  dislike: {
    es: 'No me gusta',
    en: "I don't like it",
    fr: "Je ne l'aime pas",
    it: 'Non mi piace',
    de: 'Ich mag es nicht',
    pt: 'Não gosto disso',
  },
  bought_many_to_try: {
    es: 'Compré varias opciones para probar',
    en: 'I bought several options to try',
    fr: "J'ai acheté plusieurs options pour les essayer",
    it: 'Ho comprato diverse opzioni da provare',
    de: 'Ich habe mehrere Optionen gekauft, um sie auszuprobieren',
    pt: 'Comprei várias opções para experimentar',
  },
  too_small: {
    es: 'Me queda pequeño',
    en: 'The product is too small',
    fr: 'Le produit est trop petit',
    it: 'Il prodotto è troppo piccolo',
    de: 'Das Produkt ist zu klein',
    pt: 'O produto é muito pequeno',
  },
  too_big: {
    es: 'Me queda grande',
    en: 'The product is too big',
    fr: 'Le produit est trop grand',
    it: 'Il prodotto è troppo grande',
    de: 'Das Produkt ist zu groß',
    pt: 'O produto é muito grande',
  },
  uncomfortable: {
    es: 'Es incómodo o me hace daño',
    en: 'The product is uncomfortable',
    fr: 'Le produit est inconfortable',
    it: 'Il prodotto è scomodo',
    de: 'Das Produkt ist unbequem',
    pt: 'O produto é desconfortável',
  },
  damaged: {
    es: 'El producto está dañado',
    en: 'The product is damaged',
    fr: 'Le produit est endommagé',
    it: 'Il prodotto è danneggiato',
    de: 'Das Produkt ist beschädigt',
    pt: 'O produto está danificado',
  },
  wrong_item: {
    es: 'Recibí el producto equivocado',
    en: 'I received the wrong product',
    fr: "Je n'ai pas reçu le produit correct",
    it: 'Ho ricevuto il prodotto sbagliato',
    de: 'Ich habe das falsche Produkt erhalten',
    pt: 'Recebi o produto errado',
  },
  late: {
    es: 'El producto llegó demasiado tarde',
    en: 'Product arrived too late',
    fr: 'Le produit est arrivé trop tard',
    it: 'Il prodotto è arrivato troppo tardi',
    de: 'Das Produkt ist zu spät angekommen',
    pt: 'O produto chegou tarde demais',
  },
  unable_to_exchange: {
    es: 'No es posible cambiarlo por otro producto',
    en: 'I am unable to exchange the product',
    fr: 'Je ne peux pas échanger le produit',
    it: 'Non posso scambiare il prodotto',
    de: 'Ich kann das Produkt nicht umtauschen',
    pt: 'Não consigo trocar o produto',
  },
  unknown: {
    es: 'Otro motivo',
    en: 'Other reason',
    fr: 'Autre raison',
    it: 'Altro motivo',
    de: 'Anderer Grund',
    pt: 'Outro motivo',
  },
}

export const phoneAttributesByEventName = {
  phonePrefix: 'prefix',
  phone: 'number',
}

export const isMac = typeof navigator !== 'undefined' && /mac/i.test(navigator.userAgent)

export const noPaginationParams = { pagination: false }

export const DEFAULT_SENTRY_TRACES_SAMPLE_RATE = 0.1

export const storeDateFormat = 'YYYY-MM-DD'

export const exportFormatValues = {
  csv: 'csv',
  xlsx: 'xlsx',
}

export const formats = [
  { value: exportFormatValues.csv, label: '.csv' },
  { value: exportFormatValues.xlsx, label: '.xlsx' },
]

export const platformNames = {
  [providers.shopify]: 'Shopify',
  [providers.prestashop]: 'PrestaShop',
  [providers.prestashop_with_module]: 'PrestaShop',
  [providers.apiPrestashop]: 'PrestaShop',
  [providers.woocommerce]: 'WooCommerce',
  [providers.magento]: 'Magento',
  [providers.centra]: 'Centra',
  [providers.bigcommerce]: 'BigCommerce',
  [providers.apiAmphoraShopify]: 'Shopify',
  [providers.apiIflastmileShopify]: 'Shopify',
  [providers.apiReturngoShopify]: 'Shopify',
  [providers.apiIflastmileWoocommerce]: 'WooCommerce',
}
